export const isNumeric = obj => {
  const type = typeof obj;
  return (type === "number" || type === "string") &&
  !isNaN(obj - parseFloat( obj));
}

export const format1 = (n, currency) => {
  return n.toFixed(2).replace(/./g, function(c, i, a) {
      return i > 0 && c !== "." && (a.length - i) % 3 === 0 ? " " + c : c;
  }) + ' ' + currency;
}

export const getPictureUrlFromBase64 = pictureBase64 => {
  try {
    return 'data:image/;base64,' + pictureBase64.replace(/\r\n/g, '');
  } catch (e) {
    return '';
  }
}

// export const convertDateFromSting



// WEBPACK FOOTER //
// ./src/utils/index.js